import React, { useEffect, useState } from 'react';
import { NextPage } from 'next';
import { observer } from 'mobx-react-lite';
import CardBox from 'components/common/structures/CardBox';
import RetailLayout from 'containers/retail/layouts/RetailLayout';
import { NextRouter, useRouter } from 'next/router';
import { RETAIL_RESIDENTIAL_SUCCESS_ROUTE } from 'config/retail/residential/routes';
import { FieldList, ServerError } from 'components/common/structures';
import retailStores from 'stores/retail';
import { FieldListProps } from 'components/common/structures/FieldList/FieldList';
import { createGetServerSideProps } from 'evcharging/app';
import { triggerRetailPlaceRetailEnergyOrderEvent } from 'config/seo/events';
import {I18nPage} from "i18n/types/pages.enum";
import useI18n from "evcharging/hooks/useI18n";

const ResidentialConfirmation: NextPage = observer(() => {
  const { push }: NextRouter = useRouter();
  const {
    residentialConfirmStore: {
      hasStartedSession,
      makeInformationList,
      createOrder,
      isLoading,
      errorMessage,
      clearErrorMessage,
    },
  } = retailStores;
  const [informationList, setInformationList] = useState<FieldListProps[]>([]);

  const onCompleteStep = async () =>
    createOrder(() => {
      push(RETAIL_RESIDENTIAL_SUCCESS_ROUTE);
      triggerRetailPlaceRetailEnergyOrderEvent();
    });

  useEffect(() => {
    if (hasStartedSession()) {
      setInformationList(makeInformationList());
    }
  }, [makeInformationList, hasStartedSession]);

  const { t } = useI18n();

  return (
    <RetailLayout
      activeStep={3}
      onCompleteStep={onCompleteStep}
      isLoading={isLoading}
      isResidential
    >
      <CardBox cardSpacing title={t('confirmation')}>
        {informationList.map(({ header, items }) => (
          <FieldList header={header} items={items} key={header} />
        ))}
      </CardBox>
      <ServerError onClose={clearErrorMessage} message={errorMessage} />
    </RetailLayout>
  );
});

export const getServerSideProps = createGetServerSideProps(
  undefined,
  undefined,
  [I18nPage.RetailCommon, I18nPage.RetailEnergyRates, I18nPage.RetailConfirmation]
);

export default ResidentialConfirmation;
